// extracted by mini-css-extract-plugin
export default {"image":"Style_image__8m756","modalContainer":"Style_modalContainer__Jz1xS","modal":"Style_modal__ZY7lv"};